import { render, staticRenderFns } from "./RecomendationReport.vue?vue&type=template&id=646fd11e"
import script from "./RecomendationReport.vue?vue&type=script&lang=js"
export * from "./RecomendationReport.vue?vue&type=script&lang=js"
import style0 from "./RecomendationReport.vue?vue&type=style&index=0&id=646fd11e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
